import { SerializedData } from 'in-time-core';

export interface HttpClientResponse {
  statusCode: number,
  data: SerializedData | null,
  headers: Map<string, string>,
}

export abstract class HttpClient {
  abstract get(endpoint: string, headers: Map<string, string>, params: SerializedData): Promise<HttpClientResponse>;
  abstract patch(endpoint: string, headers: Map<string, string>, body: SerializedData): Promise<HttpClientResponse>;
  abstract post(endpoint: string, headers: Map<string, string>, body: SerializedData): Promise<HttpClientResponse>;
}
